// Side Zoom Implementation (Amazon Style)
// Creates a lens overlay on the image and an external zoom window to the side.

function getFullSizeImageUrl(image) {
  if (image.srcset) {
    const srcsets = image.srcset.split(',');
    let largestUrl = image.src;
    let largestWidth = 0;
    srcsets.forEach(src => {
      const parts = src.trim().split(' ');
      if (parts.length >= 2) {
        const width = parseInt(parts[1]);
        if (width > largestWidth) {
          largestWidth = width;
          largestUrl = parts[0];
        }
      }
    });
    return largestUrl;
  }
  return image.dataset.src || image.currentSrc || image.src;
}

function enableSideZoom(zoomLevel = 2.5) {
  const images = document.querySelectorAll('.image-magnify-hover');
  let targets = Array.from(images);

  if (targets.length === 0) {
    const altImages = document.querySelectorAll('.product__media img');
    altImages.forEach(img => {
      if (img.closest('.product__modal-opener--image') || img.closest('.product__media')) {
        if (!targets.includes(img)) targets.push(img);
      }
    });
  }

  targets.forEach(image => {
    if (image.dataset.zoomInitialized) return;
    image.dataset.zoomInitialized = 'true';

    let lens = null;
    let result = null;
    let highResUrl = null;
    let isActive = false;

    const container = image.closest('.product__media') || image.parentElement;
    container.style.position = 'relative'; // Anchor for lens

    // Create the lens (transparent overlay)
    const createLens = () => {
      const el = document.createElement('div');
      el.className = 'magnify-lens';
      el.style.cssText = `
                position: absolute;
                border: 1px solid #d4d4d4;
                width: 100px; /* Base size, will be calc'd */
                height: 100px;
                background-color: rgba(255, 255, 255, 0.4);
                cursor: crosshair;
                z-index: 10;
                pointer-events: none; /* Let events fall through to container */
                display: none;
            `;
      container.appendChild(el);
      return el;
    };

    // Create the external zoom window - Append to BODY to avoid overflow clipping
    const createZoomWindow = () => {
      const el = document.createElement('div');
      el.className = 'magnify-result';
      el.style.cssText = `
                position: absolute;
                width: 500px;
                height: 500px;
                border: 1px solid #d4d4d4;
                background-color: #fff;
                z-index: 99999; /* High z-index */
                overflow: hidden;
                display: none;
                box-shadow: 0 4px 10px rgba(0,0,0,0.1);
                pointer-events: none;
            `;
      document.body.appendChild(el);
      return el;
    };

    const prepareImage = () => {
      if (!highResUrl) highResUrl = getFullSizeImageUrl(image);
    };
    // Pre-fetch
    image.addEventListener('mouseenter', prepareImage, { once: true });

    const cleanup = () => {
      if (lens) lens.style.display = 'none';
      if (result) result.style.display = 'none';
      isActive = false;
    };

    const onMouseMove = (e) => {
      // Only activate if we have a high res URL
      if (!highResUrl) prepareImage();

      // Lazy init DOM elements
      if (!lens) lens = createLens();
      if (!result) result = createZoomWindow();

      const rect = image.getBoundingClientRect();

      if (!isActive) {
        lens.style.display = 'block';
        result.style.display = 'block';
        result.style.backgroundImage = `url('${highResUrl}')`;
        result.style.backgroundSize = (image.width * zoomLevel) + 'px ' + (image.height * zoomLevel) + 'px';
        result.style.backgroundRepeat = 'no-repeat';
        isActive = true;
      }

      // Position the result window to the right of the image (global coordinates)
      const scrollX = window.pageXOffset || document.documentElement.scrollLeft;
      const scrollY = window.pageYOffset || document.documentElement.scrollTop;

      result.style.left = (rect.right + scrollX + 20) + 'px';
      result.style.top = (rect.top + scrollY) + 'px';

      // Calculate ratios
      const lensW = result.offsetWidth / zoomLevel;
      const lensH = result.offsetHeight / zoomLevel;

      lens.style.width = lensW + 'px';
      lens.style.height = lensH + 'px';

      // Coordinates relative to image
      let x = e.clientX - rect.left;
      let y = e.clientY - rect.top;

      // Prevent lens from being positioned outside the image:
      if (x > image.width - (lensW / 2)) { x = image.width - (lensW / 2); }
      if (x < lensW / 2) { x = lensW / 2; }
      if (y > image.height - (lensH / 2)) { y = image.height - (lensH / 2); }
      if (y < lensH / 2) { y = lensH / 2; }

      // Set lens position (centered on cursor)
      lens.style.left = (x - lensW / 2) + "px";
      lens.style.top = (y - lensH / 2) + "px";

      // Set result background position
      result.style.backgroundPosition = "-" + ((x - lensW / 2) * zoomLevel) + "px -" + ((y - lensH / 2) * zoomLevel) + "px";
    };

    container.addEventListener('mousemove', onMouseMove);

    // Robust cleanup listeners
    container.addEventListener('mouseleave', cleanup);
    window.addEventListener('scroll', cleanup, { passive: true });
  });
}

function initZoom() {
  setTimeout(() => {
    // Checking for touch capabilities to disable on mobile if desired
    const isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
    // We can optionally conditionally run: if (!isTouch) ...
    // For now, we enable provided user asked for it. 
    enableSideZoom(2.5);
  }, 100);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initZoom);
} else {
  initZoom();
}
